import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import MaintenanceModal from './components/MaintenanceModal';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import AdsPage from './pages/AdsPage';
import AdDetailPage from './pages/AdDetailPage';
import CreateAdPage from './pages/CreateAdPage';
import EditAdPage from './pages/EditAdPage';
import CategoriesPage from './pages/CategoriesPage';
import CategoryAdsPage from './pages/CategoryAdsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import UserProfilePage from './pages/UserProfilePage';
import ServicesPage from './pages/ServicesPage';
import MyProfilePage from './pages/MyProfilePage';
import SellerProfilePage from './pages/SellerProfilePage';
import SupportTicketsPage from './pages/SupportTicketsPage';
import NotificationsPage from './pages/NotificationsPage';
import FavoritesPage from './pages/FavoritesPage';
import ConversationsPage from './pages/ConversationsPage';
import ChatPage from './pages/ChatPage';
import MyAdsPage from './pages/MyAdsPage';
import CommissionCalculatorPage from './pages/CommissionCalculatorPage';
import AccountLayout from './components/account/AccountLayout';
import PinAdPage from './pages/PinAdPage';
import FeaturedMembershipPage from './pages/FeaturedMembershipPage';
import ContactPage from './pages/ContactPage';
import StaticPage from './pages/StaticPage';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MaintenanceModal />
        <BrowserRouter>
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 3000,
              style: {
                fontFamily: 'Cairo',
                direction: 'rtl',
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="ads" element={<AdsPage />} />
              <Route path="ads/create" element={<CreateAdPage />} />
              <Route path="ads/:id" element={<AdDetailPage />} />
              <Route path="ads/:id/edit" element={<EditAdPage />} />
              <Route element={<AccountLayout />}>
                <Route path="my/ads" element={<MyAdsPage />} />
                <Route path="my/favorites" element={<FavoritesPage />} />
                <Route path="my/conversations" element={<ConversationsPage />} />
                <Route path="my/notifications" element={<NotificationsPage />} />
                <Route path="my/support" element={<SupportTicketsPage />} />
                <Route path="my/profile" element={<MyProfilePage />} />
                <Route path="my/featured" element={<FeaturedMembershipPage />} />
                <Route path="commission" element={<CommissionCalculatorPage />} />
              </Route>
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="categories/:slug" element={<CategoryAdsPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="register" element={<RegisterPage />} />
              <Route path="forgot-password" element={<ForgotPasswordPage />} />
              <Route path="users/:id" element={<UserProfilePage />} />
              <Route path="services" element={<ServicesPage />} />
              
              <Route path="my/seller-profile" element={<SellerProfilePage />} />
              
              
              
              <Route path="my/conversations/:id" element={<ChatPage />} />
              
              
              <Route path="my/ads/:id/pin" element={<PinAdPage />} />
              
              <Route path="search" element={<AdsPage />} />
              
              <Route path="/contact" element={<ContactPage />} /> 
              <Route path="/privacy" element={<StaticPage slug="privacy" />} />
              <Route path="/terms" element={<StaticPage slug="terms" />} />
              <Route path="/about" element={<StaticPage slug="about" />} />
           </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
